import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { DBConfigCreateRequestDTO, DBConfigDeleteRequestDTO, DBConfigDTO, DBConfigList, DBConfigReadAllPaginatedRequestDTO, DBConfigReadAllRequestDTO, DBConfigReadByIdRequestDTO, DBConfigUpdatePasswordRequestDTO, DBConfigUpdateRequestDTO } from './dbconfig.interface';
import { Observable } from 'rxjs';
import { PaginatedDTO } from 'src/app/Common/common.interface';
import { DBConfig_create, DBConfig_delete, DBConfig_readAll, DBConfig_readAllPaginated, DBConfig_readById, DBConfig_update, DBConfig_updatePassword } from 'src/app/GlobalVariables';

@Injectable({
  providedIn: 'root'
})
export class DBConfigService {

  constructor() { }

  http = inject(HttpClient)

  DBConfig_create(data: DBConfigCreateRequestDTO): Observable<DBConfigDTO> {
    return this.http.post<DBConfigDTO>(DBConfig_create, data);
  }

  DBConfig_update(data: DBConfigUpdateRequestDTO): Observable<DBConfigDTO> {
    return this.http.post<DBConfigDTO>(DBConfig_update, data);
  }
  DBConfig_readById(data: DBConfigReadByIdRequestDTO): Observable<DBConfigDTO> {
    return this.http.post<DBConfigDTO>(DBConfig_readById, data);
  }
  DBConfig_readAll(data: DBConfigReadAllRequestDTO): Observable<DBConfigList> {
    return this.http.post<DBConfigList>(DBConfig_readAll, data);
  }
 DBConfig_readAllPaginated(data: DBConfigReadAllPaginatedRequestDTO): Observable<DBConfigList> {
  return this.http.post<DBConfigList>(DBConfig_readAllPaginated, data);
}

  DBConfig_delete(data: DBConfigDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(DBConfig_delete, data);
  }

  DBConfig_updatePassword(data: DBConfigUpdatePasswordRequestDTO):Observable<void>{
    return this.http.post<void>(DBConfig_updatePassword,data);
  }

}
